const newsletterPopup = () => {
  const submitForm = (e) => {
    e.preventDefault();

    const newsletterCheckboxElement = document.getElementById('newsletter');
    newsletterCheckboxElement.checked = true;

    const form = document.getElementById('edit-account-form');
    form.submit();
  }

  const popupManager = () => {
    const popupElement = document.querySelector('.unsubscribe-newsletter-popup');

    if (popupElement) {
      if (popupElement.classList.contains('hidden')) {
        popupElement.classList.remove('hidden');
      }
      else {
        popupElement.classList.add('hidden');
      }
    }
  };

  const handleChange = (e) => {
    const { currentTarget } = e;

    if (currentTarget.checked) {
      currentTarget.checked = !currentTarget.checked;
      popupManager();
    }
  };

  const attachEventListener = () => {
    const newsletterCheckboxElement = document.getElementById('newsletter');
    const popupElement = document.querySelector('.unsubscribe-newsletter-popup');

    if (popupElement) {
      const popupElementConfirm = popupElement.querySelector('button[type=submit]');
      const popupElementCancel = popupElement.querySelector('button[type=reset]');
      if (newsletterCheckboxElement && popupElement) {
        newsletterCheckboxElement.addEventListener('change', handleChange);
        popupElementConfirm.addEventListener('click', submitForm);
        popupElementCancel.addEventListener('click', popupManager);
      }
    }
  };

  const init = () => {
    const accountElement = document.getElementById('account');

    if (accountElement) {
      attachEventListener();
    }

    jQuery('body').on('click', '.modal-newsletter__close', function(e) {
      e.preventDefault();

      jQuery('#modal-newsletter').hide().remove();
    });

    var _ouibounce = ouibounce(document.getElementById('modal-newsletter'), {
      aggressive: false,
      timer: 0,
      cookieExpire: 7,
      cookieName: 'viewModalNewsletter',
      callback: function() {
        jQuery('#modal-newsletter-trigger').trigger('click');
      }
    });

    setTimeout(function() {
      _ouibounce.fire();
    }, 5000);
  };

  init();
};

export default newsletterPopup;
